import { UnitSystem } from '../interfaces/interfaces';
export type { UnitSystem };

// --- Raw conversion factors ---
export const inToMm    = (v: number): number => v * 25.4;
export const ftToM     = (v: number): number => v * 0.3048;
export const lbToKg    = (v: number): number => v * 0.453592;
export const lbftToKgm = (v: number): number => v * 1.48816;

// --- Unit label helpers ---
export const diameterUnit   = (us: UnitSystem): string => us === 'metric' ? 'mm'   : 'in';
export const lengthUnit     = (us: UnitSystem): string => us === 'metric' ? 'm'    : 'ft';
export const weightUnit     = (us: UnitSystem): string => us === 'metric' ? 'kg'   : 'lb';
export const linearMassUnit = (us: UnitSystem): string => us === 'metric' ? 'kg/m' : 'lb/ft';

// --- Formatted value converters ---

/** Converts an inch-string (e.g. "2.875") to "73.03" in metric, or returns original. */
export const convertDiameter = (inStr: string, us: UnitSystem): string => {
  if (us === 'imperial') return inStr;
  const v = parseFloat(inStr);
  return isNaN(v) ? inStr : inToMm(v).toFixed(2);
};

/** Converts feet to a display string (2 decimal places). */
export const convertLength = (ft: number, us: UnitSystem): string =>
  us === 'imperial' ? ft.toFixed(2) : ftToM(ft).toFixed(2);

/** Converts pounds to a display string (2 decimal places imperial, 3 metric). */
export const convertWeight = (lb: number, us: UnitSystem): string =>
  us === 'imperial' ? lb.toFixed(2) : lbToKg(lb).toFixed(3);

/**
 * Formats a depth value with its unit label.
 * e.g. 5000 → "5000 MD ft"  |  "1524.00 M MD"
 */
export const formatDepth = (ft: number | null | undefined, us: UnitSystem): string => {
  if (ft == null) return '';
  if (us === 'imperial') return `${ft} MD ft`;
  return `${ftToM(ft).toFixed(2)} M MD`;
};

/**
 * Parses and converts the casing OD/weight combo string.
 * Input format: "5.5 - 20"  (OD inches – linear weight lb/ft)
 * Metric output: "139.70 mm - 29.7619 kg/m"
 * Falls back to original string on parse failure.
 */
export const convertCasingOdString = (value: string, us: UnitSystem): string => {
  if (us === 'imperial') return value;
  const parts = value.split('-').map(s => s.trim());
  if (parts.length !== 2) return value;
  const od = parseFloat(parts[0]);
  const wt = parseFloat(parts[1]);
  if (isNaN(od) || isNaN(wt)) return value;
  return `${inToMm(od).toFixed(2)} mm - ${lbftToKgm(wt).toFixed(4)} kg/m`;
};
